import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOnSiteService = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#on-site-service_svg__a)">
      <path
        fill="#263E6A"
        d="m18.89 15.45-3.372 2.395a.26.26 0 0 1-.25.027l-1.453-.605a.26.26 0 0 1-.11-.391l.236-.332c-.453-.168-3.153-1.171-3.569-1.388-.435-.228-2.51-2.756-3.223-3.637h-1.89a.26.26 0 0 1 0-.519h10.706a.26.26 0 0 1 0 .52H14.74c-.084.181-.294.694-.288 1.265v.117c.002.24.005.8.074.93.114.211.611.434.928.524q.02.005.038.015l.206-.289a.26.26 0 0 1 .299-.094l2.83 1.004a.26.26 0 0 1 .063.457m-9.14-3.93c.547.536 1.11 1.029 1.285 1.078l.177.051c.247.072.685.202.863.194.118-.162.349-.757.533-1.323zm4.497 4.596.93-1.303c-.282-.095-.896-.341-1.108-.736-.12-.225-.132-.645-.135-1.171l-.001-.116c-.005-.516.132-.98.244-1.27h-1.023c-.537 1.722-.785 1.788-.905 1.82a.7.7 0 0 1-.182.021c-.243 0-.569-.088-1-.213l-.174-.05c-.435-.123-1.491-1.181-1.877-1.578H7.818c1.244 1.52 2.558 3.041 2.796 3.176.343.18 2.692 1.06 3.568 1.384a.3.3 0 0 1 .065.036m3.936-.801-2.175-.771-1.691 2.369 1.018.425z"
      />
    </g>
    <defs>
      <clipPath id="on-site-service_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgOnSiteService;
